<template src="./index.html" />
<script type="text/ecmascript-6">
import FouContainer from 'components/tools/fou-container/'
import { mapActions, mapGetters } from 'vuex'
import FouPicture from 'components/tools/fou-picture/'
import ErrorIcon from 'components/icons/error/'
import OkIcon from 'components/icons/ok/'
import AnimationProcessing from 'components/animations/processing'

export default {
  name: 'Channels',

  components: {
    FouContainer,
    FouPicture,
    ErrorIcon,
    OkIcon,
    AnimationProcessing
  },
  props: {
    foundryId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      warningUFDASrc: '../../../../../assets/images/WarningUFDA1.svg'
    }
  },
  computed: {
    ...mapGetters('contract', {
      assignedFoundries: ['list'],
      spinner: ['foundriesSpinner'],
      contractStatus: ['getContractStatus']
    }),
    getDescriptionHeadText () {
      const displayText = {
        submissions_id: this.$t('pages.channels.top_heading.new_desc'),
        live_submissions_correct: this.$t('pages.channels.top_heading.edit_desc'),
        submissions_correct: this.$t('pages.channels.top_heading.new_correct_desc'),
        submissions_details: this.$t('pages.channels.top_heading.correct_review'),
        released_submissions_details: this.$t('pages.channels.top_heading.edit_review')
      }
      return displayText[this.pathName]
    },
    pathName () {
      return this.$route.name
    },
    getSrc () {
      return this.warningUFDASrc
    },
    channelSrc () {
      return [
        {
          name: 'myFonts',
          src: './../../../../../../assets/images/myfonts.png'
        },
        {
          name: 'monotypeFonts',
          src: '../../../../../assets/images/monotypefonts.svg'
        }
      ]
    }
  },
  created () {},
  methods: {
    ...mapActions('contract', ['getAssignedFoundries'])
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';
@import 'variables/zindex';
@import 'mpl-css/lib/assets/global/mfpfonts/fonts.scss';
@import 'mpl-css/lib/assets/global/variables/colors.scss';

.picture {
  display: block;
  width: rem(140);
  margin-right: 0.5rem;
}
.listItem {
  display: inline-flex;
  align-items: center;
}
li.listItem:nth-child(2) {
  img {
    width: rem(207);
  }
}
.listItemSignup {
  display: inline-flex;
  margin-left: 50px;
}
.ulItem {
  composes: listItem;
  margin-left: 20px;
}
.ulItemSignup {
  composes: listItemSignup;
  margin-left: 0px;
}
.svgIcon {
  margin-top: 20px;
}
.ok {
  composes: svgIcon;
  background-color: #26a568 !important;
  width: rem(81) !important;
  height: rem(81) !important;
  margin-top: 0;
}
.close {
  composes: svgIcon;
  background-color: #e3152e;
}
.pageMargin {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.pageSpinner {
  width: 2.4rem;
  height: auto;
  margin-bottom: 0.75rem;
}

.releasedChannelsWarning {
  display: flex;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  @extend .mfp-HelveticaNowMTText-Regular-16;

  p {
    margin-left: rem(42);
  }
}

.channelsImageWrapper p {
  margin-left: rem(31);
}
.releasedChannelsOk {
  display: flex;
  align-items: center;
  margin-left: rem(32);
}
.descText {
  margin-bottom: rem(9);
  @extend .mfp-HelveticaNowMTText-Regular-16;
  line-height: rem(22);
}
</style>
